<template>
    <template v-if="'pages' in routeItem">
        <div
            class="section-header"
            :class="{
                expanded: props.expanded,
                selected: props.sectionOpen === props.routeItem.sectionName,
            }"
            @click="toggleSection"
            @keyup.enter="toggleSection"
        >
            <font-awesome-icon
                class="link-icon"
                :icon="props.routeItem.icon"
                :aria-label="props.routeItem.sectionName"
                :title="props.routeItem.sectionName"
            />
            <span
                v-if="props.expanded"
                class="link-text-container"
            >
                <span class="link-text">{{ props.routeItem.sectionName }}</span>
                <font-awesome-icon
                    :icon="['fas', 'angle-down']"
                    class="dropdown-icon"
                    aria-label="Toggle menu"
                    title="Toggle menu"
                />
            </span>
        </div>
        <div
            class="page-section-container"
            :class="{ open: props.sectionOpen === props.routeItem.sectionName }"
        >
            <sidebar-item
                class="sub-item"
                v-for="(subRouteItem, subRouteItemIndex) in props.routeItem.pages"
                :key="`sub-route-item-${subRouteItemIndex}`"
                :routeItem="subRouteItem"
                :expanded="props.expanded"
                @close="close"
            />
        </div>
    </template>
</template>

<script setup lang="ts">
import { ISidebarRoutesSubSection } from '@/interfaces/routing/ISidebarRoutes.ts';
import SidebarItem from '@/components/layout/sidebar/SidebarItem.vue';

const props = defineProps<{
    routeItem: ISidebarRoutesSubSection;
    sectionOpen: string | null;
    expanded: boolean;
}>();

const emit = defineEmits<{
    'toggle:section': [sectionName: string];
    close: [];
}>();

function toggleSection (): void {
    emit('toggle:section', props.routeItem.sectionName);
}

function close (): void {
    emit('close');
}
</script>

<style lang="scss" scoped>

.section-header {
    color: var(--primaryFont);
    display: grid;
    grid-template-columns: var(--sidebarWidth);
    align-items: center;
    text-decoration: none;
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;
    height: var(--sidebarRowHeight);

    &:hover {
        background-color: var(--neutral300)!important;
        color: var(--primaryFont);
    }

    .link-icon {
        justify-self: center;
        font-size: var(--largeFontSize);
    }
    .link-text-container{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: var(--defaultSpacing);

        .link-text {
            font-size: var(--smallFontSize);
            white-space: nowrap;
        }
    }

    &.expanded {
        grid-template-columns: var(--sidebarWidth) 1fr;
    }

    &.selected {
        .link-text {
            font-weight: var(--boldFontWeight);
        }
        .dropdown-icon {
            transform: rotate(180deg);
        }
    }
}

.page-section-container {
    background: var(--neutral100);
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease;
    &.open {
        transition: max-height 0.7s ease;
        max-height: 60rem;
    }
}

</style>
